import React from 'react';
import { Button } from 'lib/imports/react-md';

import './AuditPaging.scss';
import { useDispatch, useSelector } from 'react-redux';
import { auditNextPage } from 'store/ui/audit/paging/reducers';
import { useTranslation } from 'react-i18next';

const AuditPaging = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const isLoadMoreVisible = useSelector((state: any) => state.ui.audit.paging.isLoadMoreVisible);

	return (
		<>
			{
				isLoadMoreVisible && <div className="audit-paging-container">
					<Button id='loadMoreAuditsButton' className='next-page-button' flat onClick={() => {
						dispatch(auditNextPage());
					}}>{t('audit_page_load_more_button')}</Button>
				</div>
			}
		</>
	);
};

export default AuditPaging;
